import React from 'react'
import { Button, Field, makeStyles, Text, tokens } from '@fluentui/react-components'
import { t } from 'i18next'
import { ArrowLeftRegular, ArrowRightRegular } from '@fluentui/react-icons'
const useStyles = makeStyles({
   container: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      '& div & button > *': {
         color: tokens.colorNeutralForeground1,
      },
   },
   workPlaceLimit: {
      display: 'flex',
      alignItems: 'center',
   },
   number: {
      textAlign: 'center',
      fontSize: tokens.fontSizeBase300,
   },
})

type WorkPlaceLimitProps = {
   value: number
   onChange: (newValue: number) => void
   min?: number
   max?: number
}

export const WorkPlaceLimit = ({ value, onChange, min = 0, max = 500 }: WorkPlaceLimitProps) => {
   const classes = useStyles()

   const handleDecrease = () => {
      if (value > min) {
         onChange(value - 1)
      }
   }

   const handleIncrease = () => {
      if (value < max) {
         onChange(value + 1)
      }
   }

   return (
      <Field label={t('AmountOfWorkPlaces')} className={classes.container}>
         <div className={classes.workPlaceLimit}>
            <Button appearance="subtle" onClick={handleDecrease} disabled={value <= min}>
               <ArrowLeftRegular fontSize={20} />
            </Button>

            <Text className={classes.number}>{value}</Text>
            <Button appearance="subtle" onClick={handleIncrease} disabled={value >= max}>
               <ArrowRightRegular fontSize={20} />
            </Button>
         </div>
      </Field>
   )
}
